import Action from './Action';
import Add from './Add';
import AddForm from '../libs/forms/AddForm';
import Close from './Close';
import Delete from './Delete';
import Duplicate from './Duplicate';
import Download from './Download';
import DownloadUrl from './DownloadUrl';
import EditForm from '../libs/forms/EditForm';
import Expand from './Expand';
import Export from './Export';
import Launch from './Launch';
import NextPage from './NextPage';
import Options from './Options';
import PreviousPage from './PreviousPage';
import Refresh from './Refresh';

export default {
  install(Vue) {
    Vue.use(Action);
    Vue.use(Add);
    Vue.use(AddForm);
    Vue.use(Close);
    Vue.use(Delete);
    Vue.use(Download);
    Vue.use(DownloadUrl);
    Vue.use(Duplicate);
    Vue.use(EditForm);
    Vue.use(Expand);
    Vue.use(Export);
    Vue.use(Launch);
    Vue.use(NextPage);
    Vue.use(Options);
    Vue.use(PreviousPage);
    Vue.use(Refresh);
  },
};
